import fuzzyHighlight from '@jetbrains/ring-ui/components/global/fuzzy-highlight'
import type {SelectItem} from '@jetbrains/ring-ui/components/select/select'
import type {SyntheticEvent} from 'react'

import type {DockerImage, DockerTag} from '../../../../../../../../../../../../services/rest'
import {Highlight} from '../../../../../../../../../../../common/Highlight/Highlight'
import IconButton from '../../../../../../../../../../../common/IconButton/IconButton'

import styles from './JobStepRunInDockerImageSelect.css'

const VISIBLE_OPTIONS_COUNT = 8 // TODO remove it when the count parameter is implemented in the backend

export function parseDockerImage(image: string | undefined | null) {
  let imageName = null
  let tag = null

  if (image != null) {
    if (image.includes(':')) {
      const splitImage = image.split(':')
      imageName = splitImage[splitImage.length - 2] || null
      tag = splitImage[splitImage.length - 1] || null
    } else {
      imageName = image
    }
  }

  return {imageName, tag}
}

const stopPropagation = (e: SyntheticEvent) => {
  e.stopPropagation()
}

export const getSelectImagesOptions = (
  images: ReadonlyArray<DockerImage>,
  image: string | undefined | null,
): SelectItem[] =>
  images
    .map(({name = '', badges, dockerHubUrl}) => {
      const matches = image != null ? fuzzyHighlight(image, name).matches : []
      return {
        key: name,
        description: badges?.[0],
        selectedLabel: `${name}:latest`,
        label: (
          <span>
            {matches.length > 0 ? <Highlight string={name} matches={matches} /> : name}
            <span className={styles.imageTag}>{':latest'}</span>
          </span>
        ),
        rightNodes: (
          <div onClick={stopPropagation} role="presentation">
            <IconButton
              className={styles.imageLink}
              href={dockerHubUrl}
              target="_blank"
              rel="noreferrer"
              icon={'new-window'}
            />
          </div>
        ),
      }
    })
    .slice(0, VISIBLE_OPTIONS_COUNT)

export const getSelectTagsOptions = (
  tags: ReadonlyArray<DockerTag>,
  imageName: string | undefined | null,
  image: string | undefined | null,
): SelectItem[] =>
  imageName != null && image != null
    ? tags
        .map(({name}) => {
          const imageNameWithTag = `${imageName}:${name}`
          const matches = image != null ? fuzzyHighlight(image, imageNameWithTag).matches : []

          return {
            key: imageNameWithTag,
            selectedLabel: imageNameWithTag,
            label:
              matches.length > 0 ? (
                <Highlight string={imageNameWithTag} matches={matches} />
              ) : (
                imageNameWithTag
              ),
          }
        })
        .slice(0, VISIBLE_OPTIONS_COUNT)
    : []
